var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWiFiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3338 13.3103C12.7479 13.3103 11.162 13.9437 10.1358 15.12C9.20293 16.2059 7.52375 14.7581 8.45662 13.6722C9.94923 12.0435 12.0948 11.1386 14.3338 11.1386C16.5727 11.1386 18.7183 12.0435 20.2109 13.6722C21.1438 14.7581 19.4646 16.2059 18.5317 15.12C17.5055 13.9437 15.9197 13.3103 14.3338 13.3103ZM14.3338 20.9111C13.121 20.9111 12.0949 19.9158 12.0949 18.7395C12.0949 17.5631 13.121 16.5678 14.3338 16.5678C15.5465 16.5678 16.5727 17.5631 16.5727 18.7395C16.5727 19.9158 15.5465 20.9111 14.3338 20.9111ZM14.3338 7.88112C11.3485 7.88112 8.6432 8.87647 6.49758 10.9577C5.5647 11.8625 3.79223 10.5052 4.91169 9.41938C7.43046 6.97626 10.7888 5.70945 14.3338 5.70945C17.8787 5.70945 21.2371 6.97626 23.7558 9.41938C24.8753 10.5052 23.1028 11.8625 22.1699 10.9577C20.0243 8.87647 17.319 7.88112 14.3338 7.88112ZM14.3338 2.45194C10.0425 2.45194 6.03114 3.99021 2.95264 6.79528C1.83319 7.79063 0.247296 6.25237 1.36675 5.25702C5.00498 1.99951 9.48279 0.280273 14.3338 0.280273C19.1847 0.280273 23.6625 1.99951 27.3008 5.25702C28.4202 6.25237 26.8343 7.79063 25.7149 6.79528C22.6364 3.99021 18.625 2.45194 14.3338 2.45194Z",
    fill: "#8C8686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFiIcon);
export default __webpack_public_path__ + "static/media/WiFi_icon.5f8b208dae091d162bca73f7025ef213.svg";
export { ForwardRef as ReactComponent };